export const WEEKDAYS = [
  "MONDAY",
  "TUESDAY",
  "WEDNESDAY",
  "THURSDAY",
  "FRIDAY",
];

export const ALL_DAYS = [...WEEKDAYS, "SATURDAY", "SUNDAY"];

export const getUniqueTimeRanges = (timeSlots = []) => {
  const ranges = new Map();
  for (const slot of timeSlots) {
    if (!slot?.startTime || !slot?.endTime) continue;
    const key = `${slot.startTime}|${slot.endTime}`;
    if (!ranges.has(key)) {
      ranges.set(key, {
        key,
        startTime: slot.startTime,
        endTime: slot.endTime,
        label: `${slot.startTime} - ${slot.endTime}`,
      });
    }
  }
  return Array.from(ranges.values()).sort((a, b) =>
    a.startTime.localeCompare(b.startTime),
  );
};

export const buildSlotsForDays = (timeSlots = [], timeRangeKey, targetDays = []) => {
  if (!timeRangeKey) return [];
  const [startTime, endTime] = timeRangeKey.split("|");
  const built = [];

  for (const day of targetDays) {
    const match = timeSlots.find(
      (slot) =>
        slot.daysOfWeek === day &&
        slot.startTime === startTime &&
        slot.endTime === endTime,
    );
    if (match) {
      built.push({
        daysOfWeek: day,
        timeSlotId: match.timeSlotId,
      });
    }
  }

  return built;
};

export const mergeAvailabilitySlots = (existing = [], incoming = []) => {
  const merged = new Map();
  [...existing, ...incoming].forEach((slot) => {
    if (!slot?.daysOfWeek || !slot?.timeSlotId) return;
    merged.set(`${slot.daysOfWeek}-${slot.timeSlotId}`, {
      daysOfWeek: slot.daysOfWeek,
      timeSlotId: slot.timeSlotId,
    });
  });
  return Array.from(merged.values());
};
